import { Cloud } from "lucide-react";

/** Tiny pill shown above the measurement form while drafts autosave cross-device.
 *  Lifted out of StepMeasurements so it can be shared with the public /m/:orderId
 *  page without a weird default-vs-named re-import dance. */
export default function AutosaveBadge({ saving, savedAt }) {
  if (!saving && !savedAt) return null;
  return (
    <p className="text-[11px] muted-text mb-3 inline-flex items-center gap-1" data-testid="autosave-badge">
      <Cloud className="w-3 h-3" />
      {saving ? "Saving…" : "Saved — pick up where you left off on any device."}
    </p>
  );
}
